// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3ht_m","ranges":"BmiRanges_ranges__1A0v2"};